import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerHandicapMonthStatisticsDataProvider')
export class CustomerHandicapMonthStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/handicap-month/{customerId}/{month}/{year}');
    }
}
